export default {
  userRolesSection: {
    title: {
      fr: "Qui contrôle quoi... et où",
      en: "Who controls what… and where",
    },
    subtitle: {
      fr: "Utilisateurs & rôles",
      en: "Users & roles",
    },
    description: {
      fr: "Attribuez des rôles prédéfinis aux utilisateurs.",
      en: "Assign predefined roles to users.",
    },
    feature: {
      multisite: {
        title: {
          fr: "Gestion organisationnelle multisite",
          en: "Multi-site Organization Management",
        },
        subtitle: {
          fr: "Centralisez la gestion de l’ensemble de vos sites.",
          en: "Centralize the management of all your sites.",
        },
        description: {
          fr: "Administrez votre parc immobilier depuis une organisation unique avec des subdivisions régionales adaptées à votre organisation.",
          en: "Manage your entire portfolio from a single organisation with regional subdivisions tailored to your organization.",
        },
      },
    },
  },
};
